var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10V18C6 19.6569 7.34314 21 9 21H13.6H15C16.6569 21 18 19.6569 18 18V16.1V10.5V10C18 8.34315 16.6569 7 15 7H13.6H9C7.34315 7 6 8.34315 6 10Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10V18C7.5 18.8284 8.17157 19.5 9 19.5H15C15.8284 19.5 16.5 18.8284 16.5 18V10C16.5 9.17157 15.8284 8.5 15 8.5H9C8.17157 8.5 7.5 9.17157 7.5 10ZM6 18V10C6 8.34315 7.34315 7 9 7H15C16.6569 7 18 8.34315 18 10V18C18 19.6569 16.6569 21 15 21H9C7.34314 21 6 19.6569 6 18Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 5C5.25 4.58579 5.58579 4.25 6 4.25H18C18.4142 4.25 18.75 4.58579 18.75 5C18.75 5.41421 18.4142 5.75 18 5.75H6C5.58579 5.75 5.25 5.41421 5.25 5Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 4C8.25 3.58579 8.58579 3.25 9 3.25H15C15.4142 3.25 15.75 3.58579 15.75 4C15.75 4.41421 15.4142 4.75 15 4.75H9C8.58579 4.75 8.25 4.41421 8.25 4Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFilled);
export default __webpack_public_path__ + "static/media/delete_filled.ee4b904c672a09045418a41419d6fa49.svg";
export { ForwardRef as ReactComponent };